/**
 * Event status badge — shows whether an event is in progress or concluded.
 */
interface EventStatusBadgeProps {
  status: string;
}

export function EventStatusBadge({ status }: EventStatusBadgeProps): JSX.Element {
  const inProgress = status === 'active';
  const concluded = status === 'complete' || status === 'closed';
  const label = inProgress ? 'In Progress' : concluded ? 'Concluded' : status;
  const cls = inProgress ? 'status-badge in-progress' : concluded ? 'status-badge concluded' : 'status-badge';
  return (
    <span className={cls}>
      {inProgress && <span className="status-dot" aria-hidden="true" />}
      {label}
    </span>
  );
}
